<template>
  <AppDialog persistent>
    <v-card>
      <v-card-text>
        <AppIcon icon="mdi:alert" start />
        {{ $tt('form_modified_by_other') }}
      </v-card-text>

      <v-card-actions>
        <AppBtn primary @click="$emit('refresh')">
          {{ $tt('resume_saved_form') }}
        </AppBtn>
      </v-card-actions>
    </v-card>
  </AppDialog>
</template>

<script setup lang="ts">
defineEmits(['refresh']);
</script>